import React, { useState, useContext, useRef } from "react";

import {
  isEmpty,
  callApi,
  uploadImg,
  openCommonAlert,
  blockEmoji,
} from "bodycodi/cmap/app/js/common";
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";
import Img from "./img";
import change from "bodycodi/cmap/app/img/center-profile-change.png";
import ImagePickerDrawer from "./imgPickDrawer";

type CenterProfileUpdPop = {
  d: any;
  update: Function;
  updateProflie: Function;
  handleClose?: Function;
};

const CenterProfileUpdPopWrap = ({ d, update, updateProflie }: CenterProfileUpdPop) => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CENTER_PROFILE_UPD_POP",
      open: { centerProfileUpdPop: false },
    });
  };

  return (
    <CustomDialog open={state.centerProfileUpdPop} onClose={handleClose}>
      <PopupHeader onClickBack={handleClose} title="프로필 수정" />
      {state.centerProfileUpdPop && (
        <CenterProfileUpdPop
          d={d}
          update={update}
          updateProflie={updateProflie}
          handleClose={handleClose}
        />
      )}
    </CustomDialog>
  );
};

const CenterProfileUpdPop = ({ d, update, updateProflie, handleClose }: CenterProfileUpdPop) => {
  const [form, setForm] = useState<{
    coachName: string;
    bpayComment: string;
  }>({
    coachName: d.coachName,
    bpayComment: d.bpayComment || "",
  });
  const file = useRef<any>(null);
  const [url, setUrl] = useState(d.coachImgUrl);
  const { dispatch } = useContext(DispatchContext);

  const handleChange = (e: any) => {
    setForm({
      ...form,
      coachName: blockEmoji(e.target.value).trim(),
    });
  };

  const clickConfirm = () => {
    const data = {
      ...form,
      coachImgUrl: url,
      seqPartner: d.seqPartner,
      seqPartnerBranch: d.seqPartnerBranch,
      seqPartnerCoach: d.seqPartnerCoach,
    };

    callApi("/cmap5030/execPartnerBranchProfileUpd", data, "POST").then((res) => {
      update();
      updateProflie();
      handleClose!();
      if (d.mainPartnerFlag === 1) {
        dispatch({
          type: "UPDATE",
          data: {
            profileImg: url,
          },
        });
      }
    });
  };

  const selectFile = () => {
    const fileInput = file.current!.files[0];
    const fileSize = fileInput.size;
    const maxSize = 3 * 1024 * 1024;
    if (fileSize > maxSize) {
      openCommonAlert({ header: "프로필 수정", body: "3MB이상 사진은 업로드 할 수 없습니다." });
      return false;
    }
    const formData: any = new FormData();
    formData.append("file", fileInput);
    formData.append("fileNm", fileInput.name);
    formData.append("upldClStr", "coach");
    formData.append("seqPartner", d.seqPartner);

    uploadImg("/cmap5030/execCoachImgUpd", formData)
      .then((res) => {
        setUrl(res.CoachImgVO.UpldimgPath);
        closeImagePickerDrawer();
      })
      .catch(() => ({}));
  };

  const returnToDefault = () => {
    setUrl("");
    closeImagePickerDrawer();
  };

  const openImagePickerDrawer = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "IMG_PICKER_DRAWER_POP",
      open: { imgPickerDrawerPop: true },
    });
  };

  const closeImagePickerDrawer = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "IMG_PICKER_DRAWER_POP",
      open: { imgPickerDrawerPop: false },
    });
  };

  const handleOnTextAreaInput = (e: any) => {
    e.target.value = e.target.value.substring(0, 100);
    setForm({
      ...form,
      bpayComment: e.target.value,
    });
  };

  return (
    <>
      <div className="popup-body center-profile-upd-pop">
        <div className="center-profile-upd-center">
          {d?.partnerName} {d?.partnerBranchName}
        </div>
        <div className="center-profile-upd-profile">
          <label className="profile">
            <Img src={url} />
            <img className="pick" src={change} onClick={openImagePickerDrawer} />
          </label>
          <div className="input">
            <div className="name">이름</div>
            <input type="text" value={form.coachName} name="coachName" onChange={handleChange} />
          </div>
          <div className="input">
            <div className="name">강사님 한마디</div>
            <textarea
              name="bpayComment"
              value={form.bpayComment}
              maxLength={100}
              onInput={handleOnTextAreaInput}
              placeholder={
                "한마디 예시 : 국가대표 트레이너 출신의 새롭고 다양한 프로그램과 세밀한 관리로 새로운 몸으로 같이 만들어가요! (100자 제한)"
              }
            />
            <div className="text-len">
              <span>
                <span>{form.bpayComment.length}</span>/100
              </span>
            </div>
          </div>
        </div>
        <button
          className={"center-profile-upd-btn"}
          onClick={clickConfirm}
          disabled={isEmpty(form.coachName)}
        >
          완료
        </button>
      </div>
      <ImagePickerDrawer
        inputRef={file}
        onClickAlbum={selectFile}
        onClickDefault={returnToDefault}
      />
    </>
  );
};

export default CenterProfileUpdPopWrap;
